// masterDataReducer.js
import {
  FETCH_MASTER_DATA_REQUEST,
  FETCH_MASTER_DATA_SUCCESS,
  FETCH_MASTER_DATA_FAILURE,
} from "../types";

const initialState = {
  horoscopePages: [],
  loading: false,
  error: null,
};

export default function masterDataReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MASTER_DATA_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_MASTER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        horoscopePages: action.payload?.astrology || [],
      };

    case FETCH_MASTER_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
